import React, { useState, Component } from 'react';

import ItemContent from './ItemContent';

import { HiOutlineArrowRight } from 'react-icons/hi';

export class JobMaterial extends React.Component {

   // let [modalBlockActive, setBlockActive] = useState(false);
   // onClick={() => setBlockActive(modalBlockActive = !modalBlockActive)}
   render() {
      return (
         <div className='job_material--components _container' >
            <div className="job_material--block">
               {this.props.materialBlock.map(el => (
                  <ItemContent onShowItem={this.props.onShowItem} key={el.id} item={el} />
               ))}
            </div>
         </div>
      )
   }
}
export default JobMaterial;